import { ColumnConfig } from '../hooks/useTablePreferences';

export const activityLogColumns: ColumnConfig[] = [
  {
    key: 'dateTime',
    label: 'Date & Time',
    defaultWidth: 170,
    minWidth: 140,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'user',
    label: 'User',
    defaultWidth: 150,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'activityType',
    label: 'Activity Type',
    defaultWidth: 160,
    minWidth: 130,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'description',
    label: 'Description',
    defaultWidth: 250,
    minWidth: 180,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'patient',
    label: 'Patient',
    defaultWidth: 150,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'meeting',
    label: 'Meeting',
    defaultWidth: 150,
    minWidth: 120,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'actions',
    label: '',
    defaultWidth: 60,
    minWidth: 60,
    visible: true,
    sortable: false,
    resizable: false,
    draggable: false,
  },
];
